import React, { useState } from 'react'
import cx from 'classnames'
import CopyIcon from '../../../../views/components/atoms/Svgs/Copy'
import styles from './InfoList.module.scss'
import { useHover } from 'react-use'
import Tooltip from 'views/components/atoms/Tooltip/Tooltip'

type TProps = {
  className?: string
  spacing?: 'none' | 'sm' | 'md' | 'lg'
  items: {
    label: string
    value: string | React.ReactNode
    isVisible?: boolean
    onClick?: () => void
    mailTo?: boolean
    copyToClipboard?: boolean
  }[]
}

const InfoList = ({ spacing = 'lg', items, className }: TProps) => {
  const [toolTipText, setToolTipText] = useState('Click to copy to clipboard')
  const classes = cx([styles.root, styles[`spacing--${spacing}`], className])
  const isVisible = items.map((item: any) => (item.isVisible ? item.isVisible : true))

  return (
    items.length > 0 && (
      <ul className={classes}>
        {items.map((item: any, i: any) => {
          const [copyTextHoverableButton, isHovering] = useHover(
            <button
              className={styles.copy}
              onClick={() => {
                navigator.clipboard.writeText(item.value)
                setToolTipText('Copied to clipboard')
                setTimeout(() => setToolTipText('Click to copy to clipboard'), 2000)
              }}
            >
              <CopyIcon />
            </button>,
          )

          return (
            item.value &&
            isVisible && (
              <li key={i}>
                <span className={styles.label}>{item.label}</span>
                {item.mailTo ? (
                  <a className={styles.value} rel="nofollow" href={`mailto:${item.value}`}>
                    {item.value}
                  </a>
                ) : item.onClick ? (
                  <button className={styles.value} onClick={item.onClick}>
                    {item.value}
                  </button>
                ) : (
                  <span className={styles.value}>{item.value}</span>
                )}
                {item.copyToClipboard && (
                  <div className={styles.actions}>
                    <Tooltip isOpen={isHovering} body={toolTipText}>
                      {copyTextHoverableButton}
                    </Tooltip>
                  </div>
                )}
              </li>
            )
          )
        })}
      </ul>
    )
  )
}

export default InfoList
